module.exports = __webpack_public_path__ + "img/sld_ch_5_t1_green.07c6a1fb.svg";